import * as React from 'react'
// libs
import classNames from 'classnames'
import { AnimatePresence, motion } from 'motion/react'
// constants
import { maps } from '../../../../../constants/news'
// styles
import './styles.css'

const HeatmapCarousel = () => {
  const [activeIdx, setActiveIdx] = React.useState(0)
  const isFirstRender = React.useRef(true)

  React.useEffect(() => {
    const timer = setTimeout(() => {
      isFirstRender.current = false
    }, 1000)

    const interval = setInterval(() => {
      const nextIdx = (activeIdx + 1) % maps.length
      setActiveIdx(nextIdx)
    }, 6500)

    return () => {
      clearInterval(interval)
      clearTimeout(timer)
    }
  }, [activeIdx])

  const currentItem = maps[activeIdx]

  return (
    <div className='carousel-main-wrapper'>
      <div className='carousel-controls-container'>
        {maps.map((item, idx) => (
          <>
            <span
              key={idx}
              className={classNames('carousel-control-item', {
                active: idx === activeIdx,
              })}
              onClick={() => setActiveIdx(idx)}
            >
              {item.title}
            </span>
            <div
              className={classNames('carousel-control-spacer', {
                display: idx === maps?.length - 1,
              })}
            />
          </>
        ))}
      </div>
      <AnimatePresence mode='wait'>
        <motion.div
          key={activeIdx}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 1 }}
          className='hero-card'
        >
          <div>
            <div className='card-image'>
              <motion.img
                src={currentItem.image}
                alt={currentItem.alt}
                initial={
                  isFirstRender.current
                    ? { opacity: 0, y: 15 }
                    : { opacity: 1, x: 0 }
                }
                animate={{ opacity: 1, y: 0, x: 0 }}
                transition={{
                  duration: isFirstRender.current ? 1 : 0,
                }}
              />
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default HeatmapCarousel
